import { useTranslation } from 'react-i18next';
import { CampaignStatusEnum } from '../../enum/CampaignStatusEnum';
import TooltipOverlay from './tooltip/Tooltip';

interface CampaignStatusBadgeProps {
    status?: CampaignStatusEnum;
    phase?: string | number;
    className?: string;
}

const CampaignStatusBadge: React.FC<CampaignStatusBadgeProps> = ({ status, phase, className }) => {
    const { t } = useTranslation();

    if (status === CampaignStatusEnum.DRAFT && !!status) {
        return (
            <TooltipOverlay key={status} content={t(`brand.campaign.dashboard.campaignStatusTooltip-${status}`)}>
                <p className={`cursor-pointer status ${status} ${className ?? ''}`}>
                    {t(`general.campaign_status.${status}`)}
                </p>
            </TooltipOverlay>
        );
    }
    if (!!phase) {
        return (
            <TooltipOverlay key={phase} content={t(`brand.campaign.campaign_phases_enum.${phase}_description`)}>
                <p className={`cursor-pointer status phase-${phase} ${className ?? ''}`}>
                    {t(`brand.campaign.campaign_phases_enum.${phase}`)}
                </p>
            </TooltipOverlay>
        );
    }
};

export default CampaignStatusBadge;
